/** Field-by-field autosave against an optimistically locked row: saves run one after another
 *  with the latest row_version, so quick edits never conflict with each other. A newer version
 *  from fresh server data (another action bumped the row) is picked up too. */
import { useEffect, useRef, useState } from "react";

export function useChainedSave<C>(rowVersion: number, send: (changes: C, rowVersion: number) => Promise<{ row_version?: number | null }>, onDone: () => void) {
  const rv = useRef(rowVersion);
  useEffect(() => {
    if (rowVersion > rv.current) rv.current = rowVersion;
  }, [rowVersion]);
  const chain = useRef<Promise<void>>(Promise.resolve());
  const [error, setError] = useState<unknown>(null);
  const mutate = (changes: C) => {
    chain.current = chain.current.then(async () => {
      try {
        rv.current = (await send(changes, rv.current)).row_version ?? rv.current;
        setError(null);
        onDone();
      } catch (e) {
        setError(e);
      }
    });
  };
  return { mutate, error };
}
